import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="relative w-full py-24 md:py-36 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-xs font-medium text-foreground-500 uppercase tracking-wider mb-6">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-800 leading-tight">
            Explore Every
            <br />
            Product Category
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Browse through 14 carefully organized categories — from sneakers and hoodies to bags and fragrances. Every link opens directly to the curated product list.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/60 hover:bg-accent-100 hover:border-accent-200 transition-all duration-200 flex flex-col gap-3 cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </span>
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-accent-800 leading-snug whitespace-nowrap">
                {cat.displayName}
              </h3>
              <p className="text-xs text-foreground-400 group-hover:text-accent-700 leading-relaxed line-clamp-2 hidden md:block">
                {cat.description}
              </p>
              <span className="flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-800 mt-auto whitespace-nowrap">
                View Finds
                <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}